export default (uri) => window.Core.isValidURI(uri);
